import React from 'react';
import AllRoute from '../router'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LanguageProvider } from '../../i18n/LanguageContext';

const App = () => {
  return (
    <LanguageProvider>
      <div className="App" id='scrool'>
        <AllRoute />
        <ToastContainer />
      </div>
    </LanguageProvider>
  );
}

export default App;